<template>
    <PanelPage>
        <template v-slot:title>
            <SmartBreadcrumbs
                type="InertiaLink"
                :pages="[
                    {
                        name: $tc('messages.activities', 2),
                        href: meta.links.activities_index,
                    },
                    {
                        name: $tc('messages.tags', 2),
                        href: null,
                    },
                ]"
            />
        </template>

        <EmptyState v-if="subjects.length === 0" picture />
        <div v-else class="flex flex-wrap gap-x-2">
            <AppButton
                element="InertiaLink"
                :href="subject.url"
                v-for="subject in subjects"
                :key="subject.id"
                class="flex gap-x-2"
            >
                {{ subject.text }}

                <IconCircleCheckFilled class="h-5 w-5 text-indigo-600" v-if="filters.subject_id == subject.id" />
            </AppButton>
        </div>

        <div v-if="!!form.subject_id">
            <div v-if="contentBlocks.length" class="mt-5">
                <ContentBlockTagScores :content-blocks="contentBlocks" />
            </div>
            <EmptyState v-else picture />
        </div>
    </PanelPage>
</template>

<script>
import Layout from '@/Shared/Layout.vue';
import PanelPage from '@/Shared/PanelPage.vue';
import EmptyState from '@/components/EmptyState.vue';
import AppButton from '@/components/AppButton.vue';
import { IconCircleCheckFilled } from '@tabler/icons-vue';
import ContentBlockTagScores from '@/components/ContentBlockTagScores.vue';

export default {
    components: {
        ContentBlockTagScores,
        AppButton,
        PanelPage,
        EmptyState,
        IconCircleCheckFilled,
    },
    layout: Layout,
    name: 'Index',
    props: ['subjects', 'contentBlocks', 'filters', 'meta'],
    data() {
        return {
            form: this.$inertia.form({
                subject_id: this.filters.subject_id,
            }),
        };
    },
    methods: {
        filter() {
            this.form.get(this.meta.links.index);
        },
    },
};
</script>
